import { HttpClient } from "@angular/common/http";
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { PlaybookCommunicationService } from "projects/playbook-viewer/src/app/playbook-viewer/shared/services/playbook-communication.service";
import { ElectronService } from "../../services/electron/electron.service";
import { VpcCommsService } from "../../services/vpc-comms/vpc-comms.service";

@Component({
    selector: "app-online-switch",
    templateUrl: "./online-switch.component.html",
    styleUrls: ["./online-switch.component.scss"],
    standalone: false
})
export class OnlineSwitchComponent implements OnInit {
  @Input("initialState") initialState: boolean;
  onlineSwitch = new UntypedFormControl(false);
  @ViewChild("infoModal") infoModalRef: TemplateRef<any>;
  msg;
  env = {
    MainUrl: "https://vplaybook.com",
    ServerUrl: "https://api.vplaybook.com",
  };
  modalRef: BsModalRef;
  playbookUrl = null;
  appversion;
  constructor(
    private http: HttpClient,
    private electronService: ElectronService,
    private vpcService: VpcCommsService,
    private commService: PlaybookCommunicationService,
    private bsModalService: BsModalService
  ) {}

  ngOnInit() {
    this.commService.OfflineEnvironment = this.env;
    if (this.vpcService.isIOS()) {
    } else if (this.vpcService.CheckNodeWebkit()) {
      this.appversion = this.electronService.getAppVersion();
      this.electronService.Send("build-enviroment", false);
      this.electronService.on("environment", (event, environment) => {
        this.commService.OfflineEnvironment = environment;
        this.env = environment;
      });
    }
    this.onlineSwitch.setValue(this.initialState);
  }

  switchChange() {
    if (window.location.href.includes("/playbook/")) {
      this.playbookUrl =
        "/playbook/" + window.location.href.split("/playbook/")[1];
    } else {
      this.playbookUrl = null;
    }

    //TODO: @Mita - hopefully this won't get called in the future
    if (this.vpcService.isIOS()) {
      if (this.onlineSwitch.value === true) {
        window.location.href =
          this.env.MainUrl +
          (this.playbookUrl !== null ? this.playbookUrl : "/companies");
      } else {
        window.location.href =
          "app://vplaybook/" +
          (this.playbookUrl != null
            ? "playbook.html#" + this.playbookUrl
            : "playbooks.html");
      }
    } else {
      this.http
        .get(
          this.env.ServerUrl +
            "/api/OfflineApp/CheckCurrentVersion?version=" +
            this.appversion
        )
        .subscribe((res: any) => {
          if (res.Result.allowedToGoOnline) {
            if (this.onlineSwitch.value === true) {
              window.location.href =
                this.env.MainUrl +
                (this.playbookUrl !== null ? this.playbookUrl : "/companies");
            } else {
              this.electronService.Send(
                "load-url",
                this.playbookUrl !== null,
                this.playbookUrl !== null ? this.playbookUrl : "/"
              );
            }
          } else {
            this.onlineSwitch.setValue(!this.onlineSwitch.value);
            this.msg = res.Result.currentSettings.updateMessage;
            this.modalRef = this.bsModalService.show(
              this.infoModalRef,
              Object.assign(
                { class: "custom-modal" },
                {
                  ignoreBackdropClick: true,
                  keyboard: false,
                }
              )
            );
          }
        });
    }
  }
  closeModal() {
    this.modalRef.hide();
  }
}
